import React, { memo } from 'react'
import { ContentContainer } from '../../common/layouts/content-container/styles'

function Overview() {
  return <ContentContainer></ContentContainer>
}

export default memo(Overview)
